/*!
 * @fileOverview FNV Custom JS
 * @license (c) 2021 FNV
 */
import * as $ from 'jquery';
import './polyfills';

(<any> window).jQuery = $;
(<any> window).$ = $;

import 'bootstrap';

import { CookieManager } from '@fnv-core/cookies';
import { DOMReady } from '@fnv-core/dom';

import { initMenu } from './MenuController';
import { initSections } from '@fnv-core/utils/SectionUtils';
import { initForms } from './FormController';
import { initHeroPopovers } from './HeroPopoverController';
import { initModalFunctions } from './ModalController';
import { initializeOverviewPaging } from './StandardPagingController';
import { initNieuwsOverzichtController } from './NieuwsOverzichtController';
import { initCTATaskCardController } from './CTATaskCardController';
import { CookieController } from './CookieController';
import { initAZListController } from './AZController';

import { initIntersectObserve, forceLazyload } from './components/IntersectionObserver';
import { initLogoutController } from './LogoutController';
import { initContentAccordionOpeningViaUrlController } from './ContentAccordionOpeningViaUrl';
import { VideoController } from './VideoController';
import { ComponentsController } from './ComponentsController';

import { initReactController } from './ReactController';

import { getAllUrlParams } from './jslibs/urlparams';

import initialiseRoleOverride from './RoleOverride';

import { hasPageSliders, initModalCarousel } from './static/slider/pageslider-helpers';
import { InitAutocomplete } from "@fnv-static/search/Autocomplete";
import { initStatics } from './static';
import { initLocationFinder, initBulletinBoard } from '@fnv-static/widgets';
import { initWebsiteAlert } from '@fnv-static/website-alert';

require('bootstrap-select');

DOMReady(() => {

  if (window.self != window.top) {
    // Needed to know if we are being view in kentico (specifically for the pagebuilder)
    $(document.body).addClass("in-iframe");
  }

  initMenu();
  initHeroPopovers();
  initModalFunctions();
  initForms();
  initializeOverviewPaging();
  initNieuwsOverzichtController();
  initCTATaskCardController();
  initAZListController();
  initWebsiteAlert();  

  if ($(".filter").length > 0 ||
    $(".kadergroepen-info__show-more").length > 0 ||
    $(".kadergroepen-info__show-less").length > 0) {

    import('./FilterController').then((filterController) => {
      filterController.initFilterController(function () {
        initCTATaskCardController();
        forceLazyload();
      });
    });
  }

  initIntersectObserve();
  // TODO: our code acts on elements with id="root", while storybook also uses root as the root id.
  // In Storybook 7 this is changed to storybook-root
  initReactController();

  if (hasPageSliders()) {
    import('./static/slider/pageslider').then((pageslider) => {
      pageslider.initPageSliders();
    });
  }

  if ($('.pb-section').length > 0) {
    initSections();
  }

  if ($(".autocomplete-enabled").length > 0) {
    InitAutocomplete();
  }

  if ($(".location-searcher-enabled").length > 0){
    initLocationFinder();
  }
  
  if ($(".bulletinboard-enabled").length > 0){
    initBulletinBoard();
  }

  initLogoutController();
  initContentAccordionOpeningViaUrlController();

  new CookieController();
  new VideoController();
  new ComponentsController();

  if ($(".cta-container__lid-worden-button").length > 0) {
    var urlParams = getAllUrlParams();

    if (typeof urlParams["broncode"] !== "undefined") {
      $(".cta-container__lid-worden-button").each(function (index, element) {
        var currentLinkParams = getAllUrlParams($(element).attr("href"));
        if (typeof currentLinkParams["broncode"] == "undefined") {
          var separator = "?";
          if ($(element).attr("href").indexOf("?") >= 0) {
            separator = "&";
          }
          $(element).attr("href", $(".cta-container__lid-worden-button").attr("href") + separator + "broncode=" + urlParams["broncode"]);
        } else if (currentLinkParams["broncode"] == "") {
          var positionQueryParametersSeparator = $(element).attr("href").indexOf("?");
          if (positionQueryParametersSeparator >= 0) {
            var linkAddress = $(element).attr("href").substr(0, positionQueryParametersSeparator);
            var linkBuilder = linkAddress + "?";
            var separator = "";
            for (let queryParameter in currentLinkParams) {
              if (currentLinkParams.hasOwnProperty(queryParameter)) {
                if (queryParameter.toLowerCase() == "broncode") {
                  if (currentLinkParams[queryParameter] == "") {
                    linkBuilder += separator + queryParameter + "=" + urlParams["broncode"];
                  } else {
                    linkBuilder += separator + queryParameter + "=" + currentLinkParams[queryParameter];
                  }
                } else {
                  linkBuilder += separator + queryParameter + "=" + currentLinkParams[queryParameter];
                }
              }

              separator = "&";
            }

            $(element).attr("href", linkBuilder);

          } else {
            $(element).attr("href", $(".cta-container__lid-worden-button").attr("href") + "?broncode=" + urlParams["broncode"]);
          }
        }

      });
    }

  }

  if ($(".content-magazine__container").length > 0) {
    $("body").addClass("body--no-overflow-x");
  }

  var checkIfTranslated = function () {
    var checkGoogleTranslate = function () {

      var googleTranslateCookie = CookieManager.readCookie("googtrans");
      if (typeof googleTranslateCookie != "undefined" &&
        googleTranslateCookie != "" &&
        googleTranslateCookie != "/nl/nl") {
        $("#google_translate_element").addClass("googleTranslated");
      } else {
        $("#google_translate_element").removeClass("googleTranslated");
      }
    };
    setInterval(checkGoogleTranslate, 2000);
  };

  checkIfTranslated();

  initModalCarousel();

  initialiseRoleOverride();

  initStatics();

  if ($("#google_translate_element").length > 0) {
    (function () {
      var googleTranslateScript = document.createElement('script');
      googleTranslateScript.type = 'text/javascript';
      googleTranslateScript.async = true;
      googleTranslateScript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(googleTranslateScript);
    })();
  }

  /*
  The following code is needed for the Neo Sans font license from fonts.com
  */
  (<any> window).MTIProjectId = '9a8d319a-6260-41eb-9a99-6cedc202365b';
  (function () {
    var fontLicenseScript = document.createElement('script');
    fontLicenseScript.type = 'text/javascript';
    fontLicenseScript.async = true;
    fontLicenseScript.src = '//fast.fonts.net/t/1.css?apiType=css&projectid=' + (<any> window).MTIProjectId;
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(fontLicenseScript);
  })();
});